export const customRule = (value: string, regExpRule: RegExp) =>
  value.replace(regExpRule, '')

export const onlyNumbersRule = (value: string) =>
  customRule(value, /\D/g)

export const onlyNumbersAndLatinRule = (value: string) =>
  customRule(value, /[\W_]/g)

export const onlyNumbersSpacesDotsAndLatinRule = (value: string) =>
  customRule(value, /[^\w\s.]|_/g)

export const onlyMaskSeparatorsRule = (value: string) =>
  customRule(value, /[#]/g)

export const withoutSpecialSymbols = (value: string) =>
  customRule(value, /[^\p{L}\d\s_.-]/gu)

export const withoutBeginningSpaces = (value: string) =>
  customRule(value, /^\s+/)
